import { render, staticRenderFns } from "./SengLiao.vue?vue&type=template&id=96b90ee8&scoped=true"
import script from "./SengLiao.vue?vue&type=script&lang=js"
export * from "./SengLiao.vue?vue&type=script&lang=js"
import style0 from "./SengLiao.vue?vue&type=style&index=0&id=96b90ee8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b90ee8",
  null
  
)

export default component.exports